import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["questionsContainer", "questionTemplate", "archetypesContainer", "archetypeTemplate"]

  declare questionsContainerTarget: HTMLElement
  declare questionTemplateTarget: HTMLTemplateElement
  declare archetypesContainerTarget: HTMLElement
  declare archetypeTemplateTarget: HTMLTemplateElement

  addArchetype(event: Event): void {
    event.preventDefault()
    const template = this.archetypeTemplateTarget
    const index = Date.now().toString()
    const html = template.innerHTML.replace(/AIDX/g, index)
    this.archetypesContainerTarget.insertAdjacentHTML("beforeend", html)
    this.archetypesContainerTarget.lastElementChild?.querySelector<HTMLInputElement>("input[type=text]")?.focus()
  }

  removeArchetype(event: Event): void {
    event.preventDefault()
    const block = (event.target as Element).closest<HTMLElement>("[data-archetype-block]")!
    const idInput = block.querySelector<HTMLInputElement>("input[name*='[id]']")
    if (idInput?.value) {
      const destroyInput = block.querySelector<HTMLInputElement>("input[name*='_destroy']")
      if (destroyInput) destroyInput.value = "1"
      block.classList.add("hidden")
    } else {
      block.remove()
    }
  }

  addQuestion(event: Event): void {
    event.preventDefault()
    const template = this.questionTemplateTarget
    const index = Date.now().toString()
    const html = template.innerHTML.replace(/QIDX/g, index)
    this.questionsContainerTarget.insertAdjacentHTML("beforeend", html)
    this.questionsContainerTarget.lastElementChild?.querySelector<HTMLInputElement>("input[type=text]")?.focus()
  }

  removeQuestion(event: Event): void {
    event.preventDefault()
    const block = (event.target as Element).closest<HTMLElement>("[data-question-block]")!
    const idInput = block.querySelector<HTMLInputElement>("input[name*='[id]']")
    if (idInput?.value) {
      const destroyInput = block.querySelector<HTMLInputElement>("input[name*='_destroy']")
      if (destroyInput) destroyInput.value = "1"
      block.classList.add("hidden")
    } else {
      block.remove()
    }
  }

  addOption(event: Event): void {
    event.preventDefault()
    const question = (event.target as Element).closest<HTMLElement>("[data-question-block]")!
    const template = question.querySelector<HTMLTemplateElement>("[data-option-template]")!
    const container = question.querySelector<HTMLElement>("[data-options-container]")!
    const index = Date.now().toString()
    const html = template.innerHTML.replace(/OIDX/g, index)
    container.insertAdjacentHTML("beforeend", html)
    container.lastElementChild?.querySelector<HTMLInputElement>("input[type=text]")?.focus()
  }

  removeOption(event: Event): void {
    event.preventDefault()
    const block = (event.target as Element).closest<HTMLElement>("[data-option-block]")!
    const idInput = block.querySelector<HTMLInputElement>("input[name*='[id]']")
    if (idInput?.value) {
      const destroyInput = block.querySelector<HTMLInputElement>("input[name*='_destroy']")
      if (destroyInput) destroyInput.value = "1"
      block.classList.add("hidden")
    } else {
      block.remove()
    }
  }

  addProduct(event: Event): void {
    event.preventDefault()
    const archetype = (event.target as Element).closest<HTMLElement>("[data-archetype-block]")!
    const template = archetype.querySelector<HTMLTemplateElement>("[data-product-template]")!
    const container = archetype.querySelector<HTMLElement>("[data-products-container]")!
    const index = Date.now().toString()
    const html = template.innerHTML.replace(/PIDX/g, index)
    container.insertAdjacentHTML("beforeend", html)
    container.lastElementChild?.querySelector<HTMLSelectElement>("select")?.focus()
  }

  removeProduct(event: Event): void {
    event.preventDefault()
    const block = (event.target as Element).closest<HTMLElement>("[data-product-block]")!
    const idInput = block.querySelector<HTMLInputElement>("input[name*='[id]']")
    if (idInput?.value) {
      const destroyInput = block.querySelector<HTMLInputElement>("input[name*='_destroy']")
      if (destroyInput) destroyInput.value = "1"
      block.classList.add("hidden")
    } else {
      block.remove()
    }
  }
}
